export enum AcaoImportacaoEnum {
  Novo = 1,
  Atualizar = 2
}
